import { createBaseThemeOptions, palettes, createUnifiedTheme, defaultTypography } from '@backstage/theme';

import Tangram03 from '../assets/Tangram_03.svg';

export const puzzleDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#ffffffde',
        dark: '#ffffff', // 10% lighter main
        light: '#ffffffdd', // 10% darker main
      },
      secondary: {
        main: '#61B44B',
        dark: '#79C768', // 10% lighter main
        light: '#4A913A', // 10% darker main
      },
      navigation: {
        ...palettes.dark.navigation,
        background: '#1E5A96',
        color: '#ffffffff',
        indicator: '#ffffffff',
        navItem: {
          hoverBackground: '#1B5187', // 10% darker main
        },
        submenu: {
          background: '#1B5187', // 10% darker main
          color: '#ffffffff',
        },
      },
      text: {
        primary: '#ffffffff',
      },
      background: {
        default: '#333333ff',
      },
    },
  }),
  typography: {
    ...defaultTypography,
    fontFamily: 'Roboto, sans-serif',
  },
  components: {
    BackstageSidebarSubmenuItem: {
      styleOverrides: {
        selected: {
          background: '#16416bff',
        },
        item: {
          color: '#fff',
          '&:hover': {
            backgroundColor: '#246db6ff',
          },
        },
        dropdownItem: {
          '&:hover': {
            backgroundColor: '#246db6ff',
          },
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: `url(${Tangram03})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right',
        },
        title: ({ theme }) => ({
          color: theme.palette.navigation.color,
        }),
        subtitle: ({ theme }) => ({
          color: theme.palette.navigation.color,
        }),
        rightItemsBox: ({ theme }) => ({
          color: theme.palette.navigation.color,
          gap: 44,
        }),
      },
    },
    BackstageHeaderLabel: {
      styleOverrides: {
        label: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
        value: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: 'linear-gradient(135deg,#46bcc0 22.79%,#61b44b 81.45%)',
          '&:hover': {
            background: 'linear-gradient(135deg,#3da8ac 22.79%,#4a913a 81.45%)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
          },
          '&:active': {
            background: 'linear-gradient(135deg,#359197 22.79%,#3d7a2f 81.45%)',
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.main,
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: ({ theme }) => theme.palette.primary.main,
      },
    },
    PluginCatalogEntityLinksEmptyState: {
      styleOverrides: {
        code: {
          background: '#333333ff',

          '& span': {
            color: '#246db6ff',
          },
        },
      },
    },
  },
});
